export const Information = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_13429_15843)">
        <circle cx="10" cy="10" r="9.17" stroke="#A4A7B8" stroke-width="1.66" />
        <path
          d="M10 9V14"
          stroke="#A4A7B8"
          stroke-width="1.66"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <circle cx="10" cy="6" r="1" fill="#A4A7B8" />
      </g>
      <defs>
        <clipPath id="clip0_13429_15843">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
